import EN from "@/constants/en";
import { useState } from "react";
import VideoCard from "@/components/VideoCard";
import VideoModal from "@/components/VideoModal";

const DemoShowcase = () => {
    const [selectedVideo, setSelectedVideo] = useState<string | null>(null);

    const handleSelect = (id: string) => {
        setSelectedVideo(id);
    };

    const handleClose = () => {
        setSelectedVideo(null);
    };

    return (
        <section id="demos" className="section bg-white">
            <div className="container-custom">
                <h2 className="section-title">{EN.NAV_DEMOS}</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <VideoCard
                        key={EN.ABOUT_CONTACT_AI_DEMO_ID}
                        title={EN.ABOUT_CONTACT_AI_DEMO}
                        description=""
                        youtubeId={EN.ABOUT_CONTACT_AI_DEMO_ID}
                        onClick={handleSelect}
                    />
                    <VideoCard
                        key={EN.ABOUT_CONTACT_AI_DEMO_2_ID}
                        title={EN.ABOUT_CONTACT_AI_DEMO_2}
                        description=""
                        youtubeId={EN.ABOUT_CONTACT_AI_DEMO_2_ID}
                        onClick={handleSelect}
                    />
                </div>
            </div>
            {selectedVideo && <VideoModal youtubeId={selectedVideo} open={Boolean(selectedVideo)} onClose={handleClose} />}
        </section>
    );
};

export default DemoShowcase;
